export const bankData = [
  // 中央銀行 (Central Bank)
  { "code": "001", "nameEn": "CENTRAL BANK OF THE REPUBLIC OF CHINA (TAIWAN)", "nameZh": "中央銀行" },

  // 公營銀行 (Public Banks)
  { "code": "004", "nameEn": "BANK OF TAIWAN", "nameZh": "臺灣銀行" },
  { "code": "005", "nameEn": "LAND BANK OF TAIWAN", "nameZh": "臺灣土地銀行" },
  { "code": "006", "nameEn": "TAIWAN COOPERATIVE BANK", "nameZh": "合作金庫商業銀行" },
  { "code": "007", "nameEn": "FIRST COMMERCIAL BANK", "nameZh": "第一商業銀行" },
  { "code": "008", "nameEn": "HUA NAN COMMERCIAL BANK", "nameZh": "華南商業銀行" },
  { "code": "009", "nameEn": "CHANG HWA COMMERCIAL BANK", "nameZh": "彰化商業銀行" },
  { "code": "017", "nameEn": "MEGA INTERNATIONAL COMMERCIAL BANK", "nameZh": "兆豐國際商業銀行" },
  { "code": "050", "nameEn": "TAIWAN BUSINESS BANK", "nameZh": "臺灣中小企業銀行" },

  // 民營銀行 (Private Banks)
  { "code": "011", "nameEn": "THE SHANGHAI COMMERCIAL & SAVINGS BANK", "nameZh": "上海商業儲蓄銀行" },
  { "code": "012", "nameEn": "TAIPEI FUBON COMMERCIAL BANK", "nameZh": "台北富邦商業銀行" },
  { "code": "013", "nameEn": "CATHAY UNITED BANK", "nameZh": "國泰世華商業銀行" },
  { "code": "016", "nameEn": "BANK OF KAOHSIUNG", "nameZh": "高雄銀行" },
  { "code": "048", "nameEn": "WANG DOO BANK", "nameZh": "王道商業銀行" },
  { "code": "053", "nameEn": "TAICHUNG COMMERCIAL BANK", "nameZh": "台中商業銀行" },
  { "code": "054", "nameEn": "KING'S TOWN BANK", "nameZh": "京城商業銀行" },
  { "code": "101", "nameEn": "TAIPEI STAR BANK", "nameZh": "瑞興商業銀行" },
  { "code": "102", "nameEn": "HWATAI BANK", "nameZh": "華泰商業銀行" },
  { "code": "103", "nameEn": "TAIWAN SHIN KONG COMMERCIAL BANK", "nameZh": "臺灣新光商業銀行" },
  { "code": "108", "nameEn": "SUNNY BANK", "nameZh": "陽信商業銀行" },
  { "code": "147", "nameEn": "CODA COMMERCIAL BANK", "nameZh": "三信商業銀行" },
  { "code": "803", "nameEn": "UNION BANK OF TAIWAN", "nameZh": "聯邦商業銀行" },
  { "code": "805", "nameEn": "FAR EASTERN INTERNATIONAL BANK", "nameZh": "遠東國際商業銀行" },
  { "code": "806", "nameEn": "YUANTA COMMERCIAL BANK", "nameZh": "元大商業銀行" },
  { "code": "807", "nameEn": "BANK SINOPAC", "nameZh": "永豐商業銀行" },
  { "code": "808", "nameEn": "E.SUN COMMERCIAL BANK", "nameZh": "玉山商業銀行" },
  { "code": "809", "nameEn": "KGI BANK", "nameZh": "凱基商業銀行" },
  { "code": "812", "nameEn": "TAISHIN INTERNATIONAL BANK", "nameZh": "台新國際商業銀行" },
  { "code": "814", "nameEn": "TA CHONG BANK", "nameZh": "大眾商業銀行" },
  { "code": "815", "nameEn": "JIH SUN INTERNATIONAL BANK", "nameZh": "日盛國際商業銀行" },
  { "code": "816", "nameEn": "ENTRUST COMMERCIAL BANK", "nameZh": "安泰商業銀行" },
  { "code": "822", "nameEn": "CTBC BANK", "nameZh": "中國信託商業銀行" },

  // 外商銀行 (Foreign Banks)
  { "code": "015", "nameEn": "BANK OF COMMUNICATIONS", "nameZh": "交通銀行" },
  { "code": "021", "nameEn": "CITIBANK TAIWAN", "nameZh": "花旗(台灣)商業銀行" },
  { "code": "039", "nameEn": "ANZ BANK (TAIWAN)", "nameZh": "澳盛(台灣)商業銀行" },
  { "code": "052", "nameEn": "STANDARD CHARTERED BANK (TAIWAN)", "nameZh": "渣打國際商業銀行" },
  { "code": "072", "nameEn": "DEUTSCHE BANK", "nameZh": "德意志銀行台北分行" },
  { "code": "075", "nameEn": "BANK OF AMERICA", "nameZh": "美商美國銀行" },
  { "code": "076", "nameEn": "JPMORGAN CHASE BANK", "nameZh": "美商摩根大通銀行" },
  { "code": "081", "nameEn": "HSBC BANK (TAIWAN)", "nameZh": "滙豐(台灣)商業銀行" },
  { "code": "082", "nameEn": "KOREA DEVELOPMENT BANK", "nameZh": "韓國產業銀行" },
  { "code": "085", "nameEn": "BNP PARIBAS", "nameZh": "法商法國巴黎銀行" },
  { "code": "097", "nameEn": "CREDIT SUISSE", "nameZh": "瑞士信貸商業銀行" },
  { "code": "810", "nameEn": "DBS BANK (TAIWAN)", "nameZh": "星展(台灣)商業銀行" },

  // 數位銀行 (Digital Banks)
  { "code": "823", "nameEn": "NEXT BANK", "nameZh": "將來商業銀行" },
  { "code": "824", "nameEn": "LINE BANK", "nameZh": "連線商業銀行" },
  { "code": "825", "nameEn": "RAKUTEN INTERNATIONAL COMMERCIAL BANK", "nameZh": "樂天國際商業銀行" },

  // 其他金融機構 (Other Financial Institutions)
  { "code": "018", "nameEn": "AGRICULTURAL BANK OF TAIWAN", "nameZh": "全國農業金庫" },
  { "code": "512", "nameEn": "CHINA DEVELOPMENT FINANCIAL HOLDING", "nameZh": "中華開發金融控股" },

  // 票券金融公司 (Bills Finance Companies)
  { "code": "161", "nameEn": "GRAND BILLS FINANCE", "nameZh": "國際票券金融公司" },
  { "code": "162", "nameEn": "CHINA BILLS FINANCE", "nameZh": "中華票券金融公司" },
  { "code": "163", "nameEn": "MEGA BILLS FINANCE", "nameZh": "兆豐票券金融公司" },
  { "code": "164", "nameEn": "TAIWAN FINANCE", "nameZh": "台灣票券金融公司" },

  // 信用合作社 (Credit Cooperatives)
  { "code": "114", "nameEn": "KEELUNG FIRST CREDIT COOPERATIVE", "nameZh": "基隆第一信用合作社" },
  { "code": "115", "nameEn": "KEELUNG SECOND CREDIT COOPERATIVE", "nameZh": "基隆市第二信用合作社" },
  { "code": "118", "nameEn": "BANK OF PANHSIN", "nameZh": "板信商業銀行" },
  { "code": "119", "nameEn": "TAMSUI FIRST CREDIT COOPERATIVE", "nameZh": "淡水第一信用合作社" },
  { "code": "120", "nameEn": "SANCHONG CREDIT COOPERATIVE", "nameZh": "三重市信用合作社" },
  { "code": "124", "nameEn": "YILAN CREDIT COOPERATIVE", "nameZh": "宜蘭縣信用合作社" },
  { "code": "127", "nameEn": "TAOYUAN CREDIT COOPERATIVE", "nameZh": "桃園市信用合作社" },
  { "code": "130", "nameEn": "HSINCHU FIRST CREDIT COOPERATIVE", "nameZh": "新竹第一信用合作社" },
  { "code": "132", "nameEn": "HSINCHU THIRD CREDIT COOPERATIVE", "nameZh": "新竹第三信用合作社" },
  { "code": "146", "nameEn": "TAICHUNG SECOND CREDIT COOPERATIVE", "nameZh": "台中市第二信用合作社" },
  { "code": "158", "nameEn": "CHANGHUA FIRST CREDIT COOPERATIVE", "nameZh": "彰化第一信用合作社" },
  { "code": "165", "nameEn": "LUKANG CREDIT COOPERATIVE", "nameZh": "鹿港信用合作社" },
  { "code": "178", "nameEn": "CHIAYI THIRD CREDIT COOPERATIVE", "nameZh": "嘉義市第三信用合作社" },
  { "code": "179", "nameEn": "CHIAYI FOURTH CREDIT COOPERATIVE", "nameZh": "嘉義市第四信用合作社" },
  { "code": "188", "nameEn": "TAINAN THIRD CREDIT COOPERATIVE", "nameZh": "台南第三信用合作社" },
  { "code": "204", "nameEn": "KAOHSIUNG THIRD CREDIT COOPERATIVE", "nameZh": "高雄市第三信用合作社" },
  { "code": "215", "nameEn": "HUALIEN FIRST CREDIT COOPERATIVE", "nameZh": "花蓮第一信用合作社" },
  { "code": "216", "nameEn": "HUALIEN SECOND CREDIT COOPERATIVE", "nameZh": "花蓮第二信用合作社" },
  { "code": "222", "nameEn": "PENGHU FIRST CREDIT COOPERATIVE", "nameZh": "澎湖縣第一信用合作社" },
  { "code": "223", "nameEn": "PENGHU SECOND CREDIT COOPERATIVE", "nameZh": "澎湖縣第二信用合作社" },
  { "code": "224", "nameEn": "KINMEN CREDIT COOPERATIVE", "nameZh": "金門縣信用合作社" },

  // 郵政金融 (Postal Financial Services)
  { "code": "700", "nameEn": "CHUNGHWA POST", "nameZh": "中華郵政公司" },

  // 農會信用部 (Farmers' Associations Credit Departments)
  { "code": "251", "nameEn": "TAIPEI CITY FARMERS' ASSOCIATION", "nameZh": "台北市農會信用部" },
  { "code": "252", "nameEn": "SHILIN FARMERS' ASSOCIATION", "nameZh": "士林區農會信用部" },
  { "code": "253", "nameEn": "NEIHU FARMERS' ASSOCIATION", "nameZh": "內湖區農會信用部" },
  { "code": "254", "nameEn": "NANGANG FARMERS' ASSOCIATION", "nameZh": "南港區農會信用部" },
  { "code": "255", "nameEn": "MUZHA FARMERS' ASSOCIATION", "nameZh": "木柵區農會信用部" },
  { "code": "256", "nameEn": "WENSHAN FARMERS' ASSOCIATION", "nameZh": "文山區農會信用部" },
  { "code": "258", "nameEn": "BEITOU FARMERS' ASSOCIATION", "nameZh": "北投區農會信用部" },
  { "code": "260", "nameEn": "NEW TAIPEI FARMERS' ASSOCIATION", "nameZh": "新北市農會信用部" },
  { "code": "261", "nameEn": "BANQIAO FARMERS' ASSOCIATION", "nameZh": "板橋區農會信用部" },
  { "code": "262", "nameEn": "SANCHONG FARMERS' ASSOCIATION", "nameZh": "三重區農會信用部" },
  { "code": "263", "nameEn": "XINZHUANG FARMERS' ASSOCIATION", "nameZh": "新莊區農會信用部" },
  { "code": "264", "nameEn": "ZHONGHE FARMERS' ASSOCIATION", "nameZh": "中和區農會信用部" },
  { "code": "265", "nameEn": "YONGHE FARMERS' ASSOCIATION", "nameZh": "永和區農會信用部" },
  { "code": "266", "nameEn": "TUCHENG FARMERS' ASSOCIATION", "nameZh": "土城區農會信用部" },
  { "code": "267", "nameEn": "SHULIN FARMERS' ASSOCIATION", "nameZh": "樹林區農會信用部" },
  { "code": "268", "nameEn": "YINGGE FARMERS' ASSOCIATION", "nameZh": "鶯歌區農會信用部" },
  { "code": "269", "nameEn": "SANXIA FARMERS' ASSOCIATION", "nameZh": "三峽區農會信用部" },
  { "code": "270", "nameEn": "TAMSUI FARMERS' ASSOCIATION", "nameZh": "淡水區農會信用部" },
  { "code": "271", "nameEn": "BALI FARMERS' ASSOCIATION", "nameZh": "八里區農會信用部" },
  { "code": "272", "nameEn": "LINKOU FARMERS' ASSOCIATION", "nameZh": "林口區農會信用部" },
  { "code": "273", "nameEn": "WUGU FARMERS' ASSOCIATION", "nameZh": "五股區農會信用部" },
  { "code": "274", "nameEn": "TAISHAN FARMERS' ASSOCIATION", "nameZh": "泰山區農會信用部" },
  { "code": "275", "nameEn": "LUZHOU FARMERS' ASSOCIATION", "nameZh": "蘆洲區農會信用部" },
  { "code": "276", "nameEn": "SHENKENG FARMERS' ASSOCIATION", "nameZh": "深坑區農會信用部" },
  { "code": "277", "nameEn": "SHIDING FARMERS' ASSOCIATION", "nameZh": "石碇區農會信用部" },
  { "code": "278", "nameEn": "PINGXI FARMERS' ASSOCIATION", "nameZh": "平溪區農會信用部" },
  { "code": "279", "nameEn": "SHUANGXI FARMERS' ASSOCIATION", "nameZh": "雙溪區農會信用部" },
  { "code": "280", "nameEn": "GONGLIAO FARMERS' ASSOCIATION", "nameZh": "貢寮區農會信用部" },
  { "code": "281", "nameEn": "JINSHAN FARMERS' ASSOCIATION", "nameZh": "金山區農會信用部" },
  { "code": "282", "nameEn": "WANLI FARMERS' ASSOCIATION", "nameZh": "萬里區農會信用部" },
  { "code": "283", "nameEn": "RUIFANG FARMERS' ASSOCIATION", "nameZh": "瑞芳區農會信用部" },
  { "code": "284", "nameEn": "XIZHI FARMERS' ASSOCIATION", "nameZh": "汐止區農會信用部" },

  // 桃園市農會信用部 (Taoyuan Farmers' Associations)
  { "code": "290", "nameEn": "TAOYUAN COUNTY FARMERS' ASSOCIATION", "nameZh": "桃園市農會信用部" },
  { "code": "291", "nameEn": "ZHONGLI FARMERS' ASSOCIATION", "nameZh": "中壢區農會信用部" },
  { "code": "292", "nameEn": "PINGZHEN FARMERS' ASSOCIATION", "nameZh": "平鎮區農會信用部" },
  { "code": "293", "nameEn": "YANGMEI FARMERS' ASSOCIATION", "nameZh": "楊梅區農會信用部" },
  { "code": "294", "nameEn": "XINWU FARMERS' ASSOCIATION", "nameZh": "新屋區農會信用部" },
  { "code": "295", "nameEn": "GUANYIN FARMERS' ASSOCIATION", "nameZh": "觀音區農會信用部" },
  { "code": "296", "nameEn": "TAOYUAN DISTRICT FARMERS' ASSOCIATION", "nameZh": "桃園區農會信用部" },
  { "code": "297", "nameEn": "GUISHAN FARMERS' ASSOCIATION", "nameZh": "龜山區農會信用部" },
  { "code": "298", "nameEn": "BADE FARMERS' ASSOCIATION", "nameZh": "八德區農會信用部" },
  { "code": "299", "nameEn": "DAXI FARMERS' ASSOCIATION", "nameZh": "大溪區農會信用部" },
  { "code": "300", "nameEn": "LUZHU FARMERS' ASSOCIATION", "nameZh": "蘆竹區農會信用部" },
  { "code": "301", "nameEn": "DAYUAN FARMERS' ASSOCIATION", "nameZh": "大園區農會信用部" },
  { "code": "302", "nameEn": "FUXING FARMERS' ASSOCIATION", "nameZh": "復興區農會信用部" },

  // 新竹縣市農會信用部 (Hsinchu Farmers' Associations)
  { "code": "310", "nameEn": "HSINCHU CITY FARMERS' ASSOCIATION", "nameZh": "新竹市農會信用部" },
  { "code": "311", "nameEn": "HSINCHU COUNTY FARMERS' ASSOCIATION", "nameZh": "新竹縣農會信用部" },
  { "code": "312", "nameEn": "ZHUBEI FARMERS' ASSOCIATION", "nameZh": "竹北市農會信用部" },
  { "code": "313", "nameEn": "HUKOU FARMERS' ASSOCIATION", "nameZh": "湖口鄉農會信用部" },
  { "code": "314", "nameEn": "XINPU FARMERS' ASSOCIATION", "nameZh": "新埔鎮農會信用部" },
  { "code": "315", "nameEn": "GUANXI FARMERS' ASSOCIATION", "nameZh": "關西鎮農會信用部" },
  { "code": "316", "nameEn": "QIONGLIN FARMERS' ASSOCIATION", "nameZh": "芎林鄉農會信用部" },
  { "code": "317", "nameEn": "BAOSHAN FARMERS' ASSOCIATION", "nameZh": "寶山鄉農會信用部" },
  { "code": "318", "nameEn": "ZHUDONG FARMERS' ASSOCIATION", "nameZh": "竹東鎮農會信用部" },
  { "code": "319", "nameEn": "WUFENG FARMERS' ASSOCIATION", "nameZh": "五峰鄉農會信用部" },
  { "code": "320", "nameEn": "HENGSHAN FARMERS' ASSOCIATION", "nameZh": "橫山鄉農會信用部" },
  { "code": "321", "nameEn": "JIANSHI FARMERS' ASSOCIATION", "nameZh": "尖石鄉農會信用部" },
  { "code": "322", "nameEn": "BEIPU FARMERS' ASSOCIATION", "nameZh": "北埔鄉農會信用部" },
  { "code": "323", "nameEn": "EMEI FARMERS' ASSOCIATION", "nameZh": "峨眉鄉農會信用部" },

  // 苗栗縣農會信用部 (Miaoli Farmers' Associations)
  { "code": "330", "nameEn": "MIAOLI COUNTY FARMERS' ASSOCIATION", "nameZh": "苗栗縣農會信用部" },
  { "code": "331", "nameEn": "ZHUNAN FARMERS' ASSOCIATION", "nameZh": "竹南鎮農會信用部" },
  { "code": "332", "nameEn": "TOUFEN FARMERS' ASSOCIATION", "nameZh": "頭份市農會信用部" },
  { "code": "333", "nameEn": "SANWAN FARMERS' ASSOCIATION", "nameZh": "三灣鄉農會信用部" },
  { "code": "334", "nameEn": "NANZHUANG FARMERS' ASSOCIATION", "nameZh": "南庄鄉農會信用部" },
  { "code": "335", "nameEn": "SHITAN FARMERS' ASSOCIATION", "nameZh": "獅潭鄉農會信用部" },
  { "code": "336", "nameEn": "HOULONG FARMERS' ASSOCIATION", "nameZh": "後龍鎮農會信用部" },
  { "code": "337", "nameEn": "TONGXIAO FARMERS' ASSOCIATION", "nameZh": "通霄鎮農會信用部" },
  { "code": "338", "nameEn": "YUANLI FARMERS' ASSOCIATION", "nameZh": "苑裡鎮農會信用部" },
  { "code": "339", "nameEn": "MIAOLI CITY FARMERS' ASSOCIATION", "nameZh": "苗栗市農會信用部" },
  { "code": "340", "nameEn": "ZAOQIAO FARMERS' ASSOCIATION", "nameZh": "造橋鄉農會信用部" },
  { "code": "341", "nameEn": "TOUWU FARMERS' ASSOCIATION", "nameZh": "頭屋鄉農會信用部" },
  { "code": "342", "nameEn": "GONGGUAN FARMERS' ASSOCIATION", "nameZh": "公館鄉農會信用部" },
  { "code": "343", "nameEn": "DAHU FARMERS' ASSOCIATION", "nameZh": "大湖鄉農會信用部" },
  { "code": "344", "nameEn": "TAIAN FARMERS' ASSOCIATION", "nameZh": "泰安鄉農會信用部" },
  { "code": "345", "nameEn": "TONGLUO FARMERS' ASSOCIATION", "nameZh": "銅鑼鄉農會信用部" },
  { "code": "346", "nameEn": "SANYI FARMERS' ASSOCIATION", "nameZh": "三義鄉農會信用部" },
  { "code": "347", "nameEn": "XIHU FARMERS' ASSOCIATION", "nameZh": "西湖鄉農會信用部" },
  { "code": "348", "nameEn": "ZHUOLAN FARMERS' ASSOCIATION", "nameZh": "卓蘭鎮農會信用部" },

  // 台中市農會信用部 (Taichung Farmers' Associations)
  { "code": "360", "nameEn": "TAICHUNG CITY FARMERS' ASSOCIATION", "nameZh": "台中市農會信用部" },
  { "code": "361", "nameEn": "FENGYUAN FARMERS' ASSOCIATION", "nameZh": "豐原區農會信用部" },
  { "code": "362", "nameEn": "SHENGANG FARMERS' ASSOCIATION", "nameZh": "神岡區農會信用部" },
  { "code": "363", "nameEn": "DAYA FARMERS' ASSOCIATION", "nameZh": "大雅區農會信用部" },
  { "code": "364", "nameEn": "TANZI FARMERS' ASSOCIATION", "nameZh": "潭子區農會信用部" },
  { "code": "365", "nameEn": "HOULI FARMERS' ASSOCIATION", "nameZh": "后里區農會信用部" },
  { "code": "366", "nameEn": "DONGSHI FARMERS' ASSOCIATION", "nameZh": "東勢區農會信用部" },
  { "code": "367", "nameEn": "SHIGANG FARMERS' ASSOCIATION", "nameZh": "石岡區農會信用部" },
  { "code": "368", "nameEn": "XINSHE FARMERS' ASSOCIATION", "nameZh": "新社區農會信用部" },
  { "code": "369", "nameEn": "HEPING FARMERS' ASSOCIATION", "nameZh": "和平區農會信用部" },
  { "code": "370", "nameEn": "WAIPU FARMERS' ASSOCIATION", "nameZh": "外埔區農會信用部" },
  { "code": "371", "nameEn": "DAJIA FARMERS' ASSOCIATION", "nameZh": "大甲區農會信用部" },
  { "code": "372", "nameEn": "QINGSHUI FARMERS' ASSOCIATION", "nameZh": "清水區農會信用部" },
  { "code": "373", "nameEn": "WUQI FARMERS' ASSOCIATION", "nameZh": "梧棲區農會信用部" },
  { "code": "374", "nameEn": "SHALU FARMERS' ASSOCIATION", "nameZh": "沙鹿區農會信用部" },
  { "code": "375", "nameEn": "LONGJING FARMERS' ASSOCIATION", "nameZh": "龍井區農會信用部" },
  { "code": "376", "nameEn": "DADU FARMERS' ASSOCIATION", "nameZh": "大肚區農會信用部" },
  { "code": "377", "nameEn": "WURI FARMERS' ASSOCIATION", "nameZh": "烏日區農會信用部" },
  { "code": "378", "nameEn": "DALI FARMERS' ASSOCIATION", "nameZh": "大里區農會信用部" },
  { "code": "379", "nameEn": "TAIPING FARMERS' ASSOCIATION", "nameZh": "太平區農會信用部" },

  // 彰化縣農會信用部 (Changhua Farmers' Associations)
  { "code": "390", "nameEn": "CHANGHUA COUNTY FARMERS' ASSOCIATION", "nameZh": "彰化縣農會信用部" },
  { "code": "391", "nameEn": "CHANGHUA CITY FARMERS' ASSOCIATION", "nameZh": "彰化市農會信用部" },
  { "code": "392", "nameEn": "FENYUAN FARMERS' ASSOCIATION", "nameZh": "芬園鄉農會信用部" },
  { "code": "393", "nameEn": "HUATAN FARMERS' ASSOCIATION", "nameZh": "花壇鄉農會信用部" },
  { "code": "394", "nameEn": "XIUSHUI FARMERS' ASSOCIATION", "nameZh": "秀水鄉農會信用部" },
  { "code": "395", "nameEn": "LUKANG FARMERS' ASSOCIATION", "nameZh": "鹿港鎮農會信用部" },
  { "code": "396", "nameEn": "FUXING FARMERS' ASSOCIATION", "nameZh": "福興鄉農會信用部" },
  { "code": "397", "nameEn": "XIANYOU FARMERS' ASSOCIATION", "nameZh": "線西鄉農會信用部" },
  { "code": "398", "nameEn": "HEMEI FARMERS' ASSOCIATION", "nameZh": "和美鎮農會信用部" },
  { "code": "399", "nameEn": "BEIDOU FARMERS' ASSOCIATION", "nameZh": "北斗鎮農會信用部" },
  { "code": "400", "nameEn": "TIANWEI FARMERS' ASSOCIATION", "nameZh": "田尾鄉農會信用部" },
  { "code": "401", "nameEn": "PITOU FARMERS' ASSOCIATION", "nameZh": "埤頭鄉農會信用部" },
  { "code": "402", "nameEn": "XIZHOU FARMERS' ASSOCIATION", "nameZh": "溪州鄉農會信用部" },
  { "code": "403", "nameEn": "ZHUTANG FARMERS' ASSOCIATION", "nameZh": "竹塘鄉農會信用部" },
  { "code": "404", "nameEn": "ERLIN FARMERS' ASSOCIATION", "nameZh": "二林鎮農會信用部" },
  { "code": "405", "nameEn": "DACHENG FARMERS' ASSOCIATION", "nameZh": "大城鄉農會信用部" },
  { "code": "406", "nameEn": "FANGYUAN FARMERS' ASSOCIATION", "nameZh": "芳苑鄉農會信用部" },
  { "code": "407", "nameEn": "ERSHUI FARMERS' ASSOCIATION", "nameZh": "二水鄉農會信用部" },
  { "code": "408", "nameEn": "TIANZHONG FARMERS' ASSOCIATION", "nameZh": "田中鎮農會信用部" },
  { "code": "409", "nameEn": "SHETOU FARMERS' ASSOCIATION", "nameZh": "社頭鄉農會信用部" },
  { "code": "410", "nameEn": "YONGJING FARMERS' ASSOCIATION", "nameZh": "永靖鄉農會信用部" },
  { "code": "411", "nameEn": "PUYAN FARMERS' ASSOCIATION", "nameZh": "埔鹽鄉農會信用部" },
  { "code": "412", "nameEn": "PUSIN FARMERS' ASSOCIATION", "nameZh": "埔心鄉農會信用部" },
  { "code": "413", "nameEn": "YUANLIN FARMERS' ASSOCIATION", "nameZh": "員林市農會信用部" },

  // 南投縣農會信用部 (Nantou Farmers' Associations)
  { "code": "420", "nameEn": "NANTOU COUNTY FARMERS' ASSOCIATION", "nameZh": "南投縣農會信用部" },
  { "code": "421", "nameEn": "NANTOU CITY FARMERS' ASSOCIATION", "nameZh": "南投市農會信用部" },
  { "code": "422", "nameEn": "ZHONGLIAO FARMERS' ASSOCIATION", "nameZh": "中寮鄉農會信用部" },
  { "code": "423", "nameEn": "CAOTUN FARMERS' ASSOCIATION", "nameZh": "草屯鎮農會信用部" },
  { "code": "424", "nameEn": "GUOXING FARMERS' ASSOCIATION", "nameZh": "國姓鄉農會信用部" },
  { "code": "425", "nameEn": "PULI FARMERS' ASSOCIATION", "nameZh": "埔里鎮農會信用部" },
  { "code": "426", "nameEn": "RENAI FARMERS' ASSOCIATION", "nameZh": "仁愛鄉農會信用部" },
  { "code": "427", "nameEn": "MINGJIAN FARMERS' ASSOCIATION", "nameZh": "名間鄉農會信用部" },
  { "code": "428", "nameEn": "JIJI FARMERS' ASSOCIATION", "nameZh": "集集鎮農會信用部" },
  { "code": "429", "nameEn": "SHUILI FARMERS' ASSOCIATION", "nameZh": "水里鄉農會信用部" },
  { "code": "430", "nameEn": "YUCHI FARMERS' ASSOCIATION", "nameZh": "魚池鄉農會信用部" },
  { "code": "431", "nameEn": "XINYI FARMERS' ASSOCIATION", "nameZh": "信義鄉農會信用部" },
  { "code": "432", "nameEn": "ZHUSHAN FARMERS' ASSOCIATION", "nameZh": "竹山鎮農會信用部" },
  { "code": "433", "nameEn": "LUGU FARMERS' ASSOCIATION", "nameZh": "鹿谷鄉農會信用部" },

  // 雲林縣農會信用部 (Yunlin Farmers' Associations)
  { "code": "440", "nameEn": "YUNLIN COUNTY FARMERS' ASSOCIATION", "nameZh": "雲林縣農會信用部" },
  { "code": "441", "nameEn": "DOULIU FARMERS' ASSOCIATION", "nameZh": "斗六市農會信用部" },
  { "code": "442", "nameEn": "LINNEI FARMERS' ASSOCIATION", "nameZh": "林內鄉農會信用部" },
  { "code": "443", "nameEn": "GUKENG FARMERS' ASSOCIATION", "nameZh": "古坑鄉農會信用部" },
  { "code": "444", "nameEn": "CITONG FARMERS' ASSOCIATION", "nameZh": "莿桐鄉農會信用部" },
  { "code": "445", "nameEn": "HUWEI FARMERS' ASSOCIATION", "nameZh": "虎尾鎮農會信用部" },
  { "code": "446", "nameEn": "TUKU FARMERS' ASSOCIATION", "nameZh": "土庫鎮農會信用部" },
  { "code": "447", "nameEn": "BAOZHAO FARMERS' ASSOCIATION", "nameZh": "褒忠鄉農會信用部" },
  { "code": "448", "nameEn": "DONGSHI FARMERS' ASSOCIATION", "nameZh": "東勢鄉農會信用部" },
  { "code": "449", "nameEn": "TAIXI FARMERS' ASSOCIATION", "nameZh": "台西鄉農會信用部" },
  { "code": "450", "nameEn": "LUNBEI FARMERS' ASSOCIATION", "nameZh": "崙背鄉農會信用部" },
  { "code": "451", "nameEn": "MAILIAO FARMERS' ASSOCIATION", "nameZh": "麥寮鄉農會信用部" },
  { "code": "452", "nameEn": "DOUNAN FARMERS' ASSOCIATION", "nameZh": "斗南鎮農會信用部" },
  { "code": "453", "nameEn": "DAPU FARMERS' ASSOCIATION", "nameZh": "大埤鄉農會信用部" },
  { "code": "454", "nameEn": "XILUO FARMERS' ASSOCIATION", "nameZh": "西螺鎮農會信用部" },
  { "code": "455", "nameEn": "ERLUN FARMERS' ASSOCIATION", "nameZh": "二崙鄉農會信用部" },
  { "code": "456", "nameEn": "BEIGANG FARMERS' ASSOCIATION", "nameZh": "北港鎮農會信用部" },
  { "code": "457", "nameEn": "SHUILIN FARMERS' ASSOCIATION", "nameZh": "水林鄉農會信用部" },
  { "code": "458", "nameEn": "KOUHU FARMERS' ASSOCIATION", "nameZh": "口湖鄉農會信用部" },
  { "code": "459", "nameEn": "SIHU FARMERS' ASSOCIATION", "nameZh": "四湖鄉農會信用部" },
  { "code": "460", "nameEn": "YUANCHANG FARMERS' ASSOCIATION", "nameZh": "元長鄉農會信用部" },

  // 嘉義縣市農會信用部 (Chiayi Farmers' Associations)
  { "code": "470", "nameEn": "CHIAYI CITY FARMERS' ASSOCIATION", "nameZh": "嘉義市農會信用部" },
  { "code": "471", "nameEn": "CHIAYI COUNTY FARMERS' ASSOCIATION", "nameZh": "嘉義縣農會信用部" },
  { "code": "472", "nameEn": "FANLU FARMERS' ASSOCIATION", "nameZh": "番路鄉農會信用部" },
  { "code": "473", "nameEn": "MEISHAN FARMERS' ASSOCIATION", "nameZh": "梅山鄉農會信用部" },
  { "code": "474", "nameEn": "ZHUQI FARMERS' ASSOCIATION", "nameZh": "竹崎鄉農會信用部" },
  { "code": "475", "nameEn": "ALISHAN FARMERS' ASSOCIATION", "nameZh": "阿里山鄉農會信用部" },
  { "code": "476", "nameEn": "ZHONGPU FARMERS' ASSOCIATION", "nameZh": "中埔鄉農會信用部" },
  { "code": "477", "nameEn": "DAPU FARMERS' ASSOCIATION", "nameZh": "大埔鄉農會信用部" },
  { "code": "478", "nameEn": "SHUISHANG FARMERS' ASSOCIATION", "nameZh": "水上鄉農會信用部" },
  { "code": "479", "nameEn": "LUCAO FARMERS' ASSOCIATION", "nameZh": "鹿草鄉農會信用部" },
  { "code": "480", "nameEn": "TAIBAO FARMERS' ASSOCIATION", "nameZh": "太保市農會信用部" },
  { "code": "481", "nameEn": "PUZI FARMERS' ASSOCIATION", "nameZh": "朴子市農會信用部" },
  { "code": "482", "nameEn": "DONGSHI FARMERS' ASSOCIATION", "nameZh": "東石鄉農會信用部" },
  { "code": "483", "nameEn": "LIUJIAO FARMERS' ASSOCIATION", "nameZh": "六腳鄉農會信用部" },
  { "code": "484", "nameEn": "XINGANG FARMERS' ASSOCIATION", "nameZh": "新港鄉農會信用部" },
  { "code": "485", "nameEn": "MINXIONG FARMERS' ASSOCIATION", "nameZh": "民雄鄉農會信用部" },
  { "code": "486", "nameEn": "DALIN FARMERS' ASSOCIATION", "nameZh": "大林鎮農會信用部" },
  { "code": "487", "nameEn": "XIKOU FARMERS' ASSOCIATION", "nameZh": "溪口鄉農會信用部" },
  { "code": "488", "nameEn": "YIZHU FARMERS' ASSOCIATION", "nameZh": "義竹鄉農會信用部" },
  { "code": "489", "nameEn": "BUDAI FARMERS' ASSOCIATION", "nameZh": "布袋鎮農會信用部" },

  // 台南市農會信用部 (Tainan Farmers' Associations)
  { "code": "500", "nameEn": "TAINAN CITY FARMERS' ASSOCIATION", "nameZh": "台南市農會信用部" },
  { "code": "501", "nameEn": "YANSHUI FARMERS' ASSOCIATION", "nameZh": "鹽水區農會信用部" },
  { "code": "502", "nameEn": "BAIHE FARMERS' ASSOCIATION", "nameZh": "白河區農會信用部" },
  { "code": "503", "nameEn": "LIUJIA FARMERS' ASSOCIATION", "nameZh": "柳營區農會信用部" },
  { "code": "504", "nameEn": "HOUBI FARMERS' ASSOCIATION", "nameZh": "後壁區農會信用部" },
  { "code": "505", "nameEn": "DONGSHAN FARMERS' ASSOCIATION", "nameZh": "東山區農會信用部" },
  { "code": "506", "nameEn": "LIUYING FARMERS' ASSOCIATION", "nameZh": "六甲區農會信用部" },
  { "code": "507", "nameEn": "XIAYING FARMERS' ASSOCIATION", "nameZh": "下營區農會信用部" },
  { "code": "508", "nameEn": "JIALI FARMERS' ASSOCIATION", "nameZh": "佳里區農會信用部" },
  { "code": "509", "nameEn": "XIGANG FARMERS' ASSOCIATION", "nameZh": "西港區農會信用部" },
  { "code": "510", "nameEn": "QIGU FARMERS' ASSOCIATION", "nameZh": "七股區農會信用部" },
  { "code": "511", "nameEn": "JIANGJUN FARMERS' ASSOCIATION", "nameZh": "將軍區農會信用部" },
  { "code": "512", "nameEn": "BEIMEN FARMERS' ASSOCIATION", "nameZh": "北門區農會信用部" },
  { "code": "513", "nameEn": "XINHUA FARMERS' ASSOCIATION", "nameZh": "新化區農會信用部" },
  { "code": "514", "nameEn": "SHANHUA FARMERS' ASSOCIATION", "nameZh": "善化區農會信用部" },
  { "code": "515", "nameEn": "XINSHI FARMERS' ASSOCIATION", "nameZh": "新市區農會信用部" },
  { "code": "516", "nameEn": "ANDING FARMERS' ASSOCIATION", "nameZh": "安定區農會信用部" },
  { "code": "517", "nameEn": "SHANSHANG FARMERS' ASSOCIATION", "nameZh": "山上區農會信用部" },
  { "code": "518", "nameEn": "YUJING FARMERS' ASSOCIATION", "nameZh": "玉井區農會信用部" },
  { "code": "519", "nameEn": "NANXI FARMERS' ASSOCIATION", "nameZh": "楠西區農會信用部" },
  { "code": "520", "nameEn": "NANHUA FARMERS' ASSOCIATION", "nameZh": "南化區農會信用部" },
  { "code": "521", "nameEn": "ZUOZHEN FARMERS' ASSOCIATION", "nameZh": "左鎮區農會信用部" },
  { "code": "522", "nameEn": "RENDE FARMERS' ASSOCIATION", "nameZh": "仁德區農會信用部" },
  { "code": "523", "nameEn": "GUIREN FARMERS' ASSOCIATION", "nameZh": "歸仁區農會信用部" },
  { "code": "524", "nameEn": "GUANMIAO FARMERS' ASSOCIATION", "nameZh": "關廟區農會信用部" },
  { "code": "525", "nameEn": "LONGQI FARMERS' ASSOCIATION", "nameZh": "龍崎區農會信用部" },
  { "code": "526", "nameEn": "YONGKANG FARMERS' ASSOCIATION", "nameZh": "永康區農會信用部" },

  // 高雄市農會信用部 (Kaohsiung Farmers' Associations)
  { "code": "540", "nameEn": "KAOHSIUNG CITY FARMERS' ASSOCIATION", "nameZh": "高雄市農會信用部" },
  { "code": "541", "nameEn": "FENGSHAN FARMERS' ASSOCIATION", "nameZh": "鳳山區農會信用部" },
  { "code": "542", "nameEn": "GANGSHAN FARMERS' ASSOCIATION", "nameZh": "岡山區農會信用部" },
  { "code": "543", "nameEn": "QIAOTOU FARMERS' ASSOCIATION", "nameZh": "橋頭區農會信用部" },
  { "code": "544", "nameEn": "YANCHAO FARMERS' ASSOCIATION", "nameZh": "燕巢區農會信用部" },
  { "code": "545", "nameEn": "TIANLIAO FARMERS' ASSOCIATION", "nameZh": "田寮區農會信用部" },
  { "code": "546", "nameEn": "ALIAN FARMERS' ASSOCIATION", "nameZh": "阿蓮區農會信用部" },
  { "code": "547", "nameEn": "LUZHU FARMERS' ASSOCIATION", "nameZh": "路竹區農會信用部" },
  { "code": "548", "nameEn": "HUNEI FARMERS' ASSOCIATION", "nameZh": "湖內區農會信用部" },
  { "code": "549", "nameEn": "QISHAN FARMERS' ASSOCIATION", "nameZh": "旗山區農會信用部" },
  { "code": "550", "nameEn": "MEINONG FARMERS' ASSOCIATION", "nameZh": "美濃區農會信用部" },
  { "code": "551", "nameEn": "LIUGUI FARMERS' ASSOCIATION", "nameZh": "六龜區農會信用部" },
  { "code": "552", "nameEn": "JIAXIAN FARMERS' ASSOCIATION", "nameZh": "甲仙區農會信用部" },
  { "code": "553", "nameEn": "SHANLIN FARMERS' ASSOCIATION", "nameZh": "杉林區農會信用部" },
  { "code": "554", "nameEn": "NEIMEN FARMERS' ASSOCIATION", "nameZh": "內門區農會信用部" },
  { "code": "555", "nameEn": "MAOLIN FARMERS' ASSOCIATION", "nameZh": "茂林區農會信用部" },
  { "code": "556", "nameEn": "TAOYUAN FARMERS' ASSOCIATION", "nameZh": "桃源區農會信用部" },
  { "code": "557", "nameEn": "NAMAXIA FARMERS' ASSOCIATION", "nameZh": "那瑪夏區農會信用部" },
  { "code": "558", "nameEn": "YONGAN FARMERS' ASSOCIATION", "nameZh": "永安區農會信用部" },
  { "code": "559", "nameEn": "MITUO FARMERS' ASSOCIATION", "nameZh": "彌陀區農會信用部" },
  { "code": "560", "nameEn": "ZIGUAN FARMERS' ASSOCIATION", "nameZh": "梓官區農會信用部" },

  // 屏東縣農會信用部 (Pingtung Farmers' Associations)
  { "code": "570", "nameEn": "PINGTUNG COUNTY FARMERS' ASSOCIATION", "nameZh": "屏東縣農會信用部" },
  { "code": "571", "nameEn": "PINGTUNG CITY FARMERS' ASSOCIATION", "nameZh": "屏東市農會信用部" },
  { "code": "572", "nameEn": "SANDIMEN FARMERS' ASSOCIATION", "nameZh": "三地門鄉農會信用部" },
  { "code": "573", "nameEn": "WUTAI FARMERS' ASSOCIATION", "nameZh": "霧台鄉農會信用部" },
  { "code": "574", "nameEn": "MAJIA FARMERS' ASSOCIATION", "nameZh": "瑪家鄉農會信用部" },
  { "code": "575", "nameEn": "JIURU FARMERS' ASSOCIATION", "nameZh": "九如鄉農會信用部" },
  { "code": "576", "nameEn": "LIGANG FARMERS' ASSOCIATION", "nameZh": "里港鄉農會信用部" },
  { "code": "577", "nameEn": "GAOSHU FARMERS' ASSOCIATION", "nameZh": "高樹鄉農會信用部" },
  { "code": "578", "nameEn": "YANCHENG FARMERS' ASSOCIATION", "nameZh": "鹽埔鄉農會信用部" },
  { "code": "579", "nameEn": "CHANGZHI FARMERS' ASSOCIATION", "nameZh": "長治鄉農會信用部" },
  { "code": "580", "nameEn": "LINLUO FARMERS' ASSOCIATION", "nameZh": "麟洛鄉農會信用部" },
  { "code": "581", "nameEn": "ZHUTIAN FARMERS' ASSOCIATION", "nameZh": "竹田鄉農會信用部" },
  { "code": "582", "nameEn": "NEIPU FARMERS' ASSOCIATION", "nameZh": "內埔鄉農會信用部" },
  { "code": "583", "nameEn": "WANLUAN FARMERS' ASSOCIATION", "nameZh": "萬巒鄉農會信用部" },
  { "code": "584", "nameEn": "CHAOZHOU FARMERS' ASSOCIATION", "nameZh": "潮州鎮農會信用部" },
  { "code": "585", "nameEn": "TAIWU FARMERS' ASSOCIATION", "nameZh": "泰武鄉農會信用部" },
  { "code": "586", "nameEn": "LAIYI FARMERS' ASSOCIATION", "nameZh": "來義鄉農會信用部" },
  { "code": "587", "nameEn": "WANDAN FARMERS' ASSOCIATION", "nameZh": "萬丹鄉農會信用部" },
  { "code": "588", "nameEn": "XINPI FARMERS' ASSOCIATION", "nameZh": "新埤鄉農會信用部" },
  { "code": "589", "nameEn": "NANZHOU FARMERS' ASSOCIATION", "nameZh": "南州鄉農會信用部" },
  { "code": "590", "nameEn": "LINBIAN FARMERS' ASSOCIATION", "nameZh": "林邊鄉農會信用部" },
  { "code": "591", "nameEn": "DONGGANG FARMERS' ASSOCIATION", "nameZh": "東港鎮農會信用部" },
  { "code": "592", "nameEn": "LIUQIU FARMERS' ASSOCIATION", "nameZh": "琉球鄉農會信用部" },
  { "code": "593", "nameEn": "JIADONG FARMERS' ASSOCIATION", "nameZh": "佳冬鄉農會信用部" },
  { "code": "594", "nameEn": "FANGLIAO FARMERS' ASSOCIATION", "nameZh": "枋寮鄉農會信用部" },
  { "code": "595", "nameEn": "FANGSHAN FARMERS' ASSOCIATION", "nameZh": "枋山鄉農會信用部" },
  { "code": "596", "nameEn": "CHUNRI FARMERS' ASSOCIATION", "nameZh": "春日鄉農會信用部" },
  { "code": "597", "nameEn": "SHIZI FARMERS' ASSOCIATION", "nameZh": "獅子鄉農會信用部" },
  { "code": "598", "nameEn": "CHECHENG FARMERS' ASSOCIATION", "nameZh": "車城鄉農會信用部" },
  { "code": "599", "nameEn": "MUDAN FARMERS' ASSOCIATION", "nameZh": "牡丹鄉農會信用部" },
  { "code": "600", "nameEn": "HENGCHUN FARMERS' ASSOCIATION", "nameZh": "恆春鎮農會信用部" },
  { "code": "601", "nameEn": "MANJHOU FARMERS' ASSOCIATION", "nameZh": "滿州鄉農會信用部" },

  // 宜蘭縣農會信用部 (Yilan Farmers' Associations)
  { "code": "610", "nameEn": "YILAN COUNTY FARMERS' ASSOCIATION", "nameZh": "宜蘭縣農會信用部" },
  { "code": "611", "nameEn": "YILAN CITY FARMERS' ASSOCIATION", "nameZh": "宜蘭市農會信用部" },
  { "code": "612", "nameEn": "TOUCHENG FARMERS' ASSOCIATION", "nameZh": "頭城鎮農會信用部" },
  { "code": "613", "nameEn": "JIAOXI FARMERS' ASSOCIATION", "nameZh": "礁溪鄉農會信用部" },
  { "code": "614", "nameEn": "ZHUANGWEI FARMERS' ASSOCIATION", "nameZh": "壯圍鄉農會信用部" },
  { "code": "615", "nameEn": "YUANSHAN FARMERS' ASSOCIATION", "nameZh": "員山鄉農會信用部" },
  { "code": "616", "nameEn": "LUODONG FARMERS' ASSOCIATION", "nameZh": "羅東鎮農會信用部" },
  { "code": "617", "nameEn": "SANXING FARMERS' ASSOCIATION", "nameZh": "三星鄉農會信用部" },
  { "code": "618", "nameEn": "DATONG FARMERS' ASSOCIATION", "nameZh": "大同鄉農會信用部" },
  { "code": "619", "nameEn": "WUJIE FARMERS' ASSOCIATION", "nameZh": "五結鄉農會信用部" },
  { "code": "620", "nameEn": "DONGSHAN FARMERS' ASSOCIATION", "nameZh": "冬山鄉農會信用部" },
  { "code": "621", "nameEn": "SUAO FARMERS' ASSOCIATION", "nameZh": "蘇澳鎮農會信用部" },
  { "code": "622", "nameEn": "NANAO FARMERS' ASSOCIATION", "nameZh": "南澳鄉農會信用部" },

  // 花蓮縣農會信用部 (Hualien Farmers' Associations)
  { "code": "630", "nameEn": "HUALIEN COUNTY FARMERS' ASSOCIATION", "nameZh": "花蓮縣農會信用部" },
  { "code": "631", "nameEn": "HUALIEN CITY FARMERS' ASSOCIATION", "nameZh": "花蓮市農會信用部" },
  { "code": "632", "nameEn": "XINCHENG FARMERS' ASSOCIATION", "nameZh": "新城鄉農會信用部" },
  { "code": "633", "nameEn": "XIULIN FARMERS' ASSOCIATION", "nameZh": "秀林鄉農會信用部" },
  { "code": "634", "nameEn": "JIAN FARMERS' ASSOCIATION", "nameZh": "吉安鄉農會信用部" },
  { "code": "635", "nameEn": "SHOUFENG FARMERS' ASSOCIATION", "nameZh": "壽豐鄉農會信用部" },
  { "code": "636", "nameEn": "FENGLIN FARMERS' ASSOCIATION", "nameZh": "鳳林鎮農會信用部" },
  { "code": "637", "nameEn": "GUANGFU FARMERS' ASSOCIATION", "nameZh": "光復鄉農會信用部" },
  { "code": "638", "nameEn": "RUISUI FARMERS' ASSOCIATION", "nameZh": "瑞穗鄉農會信用部" },
  { "code": "639", "nameEn": "WANRONG FARMERS' ASSOCIATION", "nameZh": "萬榮鄉農會信用部" },
  { "code": "640", "nameEn": "YULI FARMERS' ASSOCIATION", "nameZh": "玉里鎮農會信用部" },
  { "code": "641", "nameEn": "ZHUOXI FARMERS' ASSOCIATION", "nameZh": "卓溪鄉農會信用部" },
  { "code": "642", "nameEn": "FULI FARMERS' ASSOCIATION", "nameZh": "富里鄉農會信用部" },

  // 台東縣農會信用部 (Taitung Farmers' Associations)
  { "code": "650", "nameEn": "TAITUNG COUNTY FARMERS' ASSOCIATION", "nameZh": "台東縣農會信用部" },
  { "code": "651", "nameEn": "TAITUNG CITY FARMERS' ASSOCIATION", "nameZh": "台東市農會信用部" },
  { "code": "652", "nameEn": "CHENGGONG FARMERS' ASSOCIATION", "nameZh": "成功鎮農會信用部" },
  { "code": "653", "nameEn": "GUANSHAN FARMERS' ASSOCIATION", "nameZh": "關山鎮農會信用部" },
  { "code": "654", "nameEn": "CHISHANG FARMERS' ASSOCIATION", "nameZh": "池上鄉農會信用部" },
  { "code": "655", "nameEn": "DONGHE FARMERS' ASSOCIATION", "nameZh": "東河鄉農會信用部" },
  { "code": "656", "nameEn": "CHANGBIN FARMERS' ASSOCIATION", "nameZh": "長濱鄉農會信用部" },
  { "code": "657", "nameEn": "LUYE FARMERS' ASSOCIATION", "nameZh": "鹿野鄉農會信用部" },
  { "code": "658", "nameEn": "YANPING FARMERS' ASSOCIATION", "nameZh": "延平鄉農會信用部" },
  { "code": "659", "nameEn": "HAIDUAN FARMERS' ASSOCIATION", "nameZh": "海端鄉農會信用部" },
  { "code": "660", "nameEn": "BEINAN FARMERS' ASSOCIATION", "nameZh": "卑南鄉農會信用部" },
  { "code": "661", "nameEn": "TAIMALI FARMERS' ASSOCIATION", "nameZh": "太麻里鄉農會信用部" },
  { "code": "662", "nameEn": "JINFENG FARMERS' ASSOCIATION", "nameZh": "金峰鄉農會信用部" },
  { "code": "663", "nameEn": "DAREN FARMERS' ASSOCIATION", "nameZh": "大武鄉農會信用部" },
  { "code": "664", "nameEn": "DAWU FARMERS' ASSOCIATION", "nameZh": "達仁鄉農會信用部" },
  { "code": "665", "nameEn": "LANYU FARMERS' ASSOCIATION", "nameZh": "蘭嶼鄉農會信用部" },

  // 澎湖縣農會信用部 (Penghu Farmers' Associations)
  { "code": "680", "nameEn": "PENGHU COUNTY FARMERS' ASSOCIATION", "nameZh": "澎湖縣農會信用部" },
  { "code": "681", "nameEn": "MAGONG FARMERS' ASSOCIATION", "nameZh": "馬公市農會信用部" },
  { "code": "682", "nameEn": "HUXI FARMERS' ASSOCIATION", "nameZh": "湖西鄉農會信用部" },
  { "code": "683", "nameEn": "BAISHA FARMERS' ASSOCIATION", "nameZh": "白沙鄉農會信用部" },
  { "code": "684", "nameEn": "XIYU FARMERS' ASSOCIATION", "nameZh": "西嶼鄉農會信用部" },
  { "code": "685", "nameEn": "WANGAN FARMERS' ASSOCIATION", "nameZh": "望安鄉農會信用部" },
  { "code": "686", "nameEn": "QIMEI FARMERS' ASSOCIATION", "nameZh": "七美鄉農會信用部" },

  // 金門縣農會信用部 (Kinmen Farmers' Associations)
  { "code": "690", "nameEn": "KINMEN COUNTY FARMERS' ASSOCIATION", "nameZh": "金門縣農會信用部" },
  { "code": "691", "nameEn": "JINCHENG FARMERS' ASSOCIATION", "nameZh": "金城鎮農會信用部" },
  { "code": "692", "nameEn": "JINSHA FARMERS' ASSOCIATION", "nameZh": "金沙鎮農會信用部" },
  { "code": "693", "nameEn": "JINHU FARMERS' ASSOCIATION", "nameZh": "金湖鎮農會信用部" },
  { "code": "694", "nameEn": "JINNING FARMERS' ASSOCIATION", "nameZh": "金寧鄉農會信用部" },
  { "code": "695", "nameEn": "LIEYU FARMERS' ASSOCIATION", "nameZh": "烈嶼鄉農會信用部" },

  // 連江縣農會信用部 (Lienchiang Farmers' Associations)
  { "code": "698", "nameEn": "LIENCHIANG COUNTY FARMERS' ASSOCIATION", "nameZh": "連江縣農會信用部" },
  { "code": "699", "nameEn": "NANGAN FARMERS' ASSOCIATION", "nameZh": "南竿鄉農會信用部" },

  // 漁會信用部 (Fishermen's Associations Credit Departments)
  { "code": "951", "nameEn": "KEELUNG FISHERMEN'S ASSOCIATION", "nameZh": "基隆區漁會信用部" },
  { "code": "952", "nameEn": "TOUCHENG FISHERMEN'S ASSOCIATION", "nameZh": "頭城區漁會信用部" },
  { "code": "953", "nameEn": "SUAO FISHERMEN'S ASSOCIATION", "nameZh": "蘇澳區漁會信用部" },
  { "code": "954", "nameEn": "NANFANGAO FISHERMEN'S ASSOCIATION", "nameZh": "南方澳區漁會信用部" },
  { "code": "955", "nameEn": "YILAN FISHERMEN'S ASSOCIATION", "nameZh": "宜蘭區漁會信用部" },
  { "code": "956", "nameEn": "HSINCHU FISHERMEN'S ASSOCIATION", "nameZh": "新竹區漁會信用部" },
  { "code": "957", "nameEn": "TAICHUNG FISHERMEN'S ASSOCIATION", "nameZh": "台中區漁會信用部" },
  { "code": "958", "nameEn": "CHANGHUA FISHERMEN'S ASSOCIATION", "nameZh": "彰化區漁會信用部" },
  { "code": "959", "nameEn": "YUNLIN FISHERMEN'S ASSOCIATION", "nameZh": "雲林區漁會信用部" },
  { "code": "960", "nameEn": "CHIAYI FISHERMEN'S ASSOCIATION", "nameZh": "嘉義區漁會信用部" },
  { "code": "961", "nameEn": "TAINAN FISHERMEN'S ASSOCIATION", "nameZh": "台南市漁會信用部" },
  { "code": "962", "nameEn": "KAOHSIUNG FISHERMEN'S ASSOCIATION", "nameZh": "高雄區漁會信用部" },
  { "code": "963", "nameEn": "PINGTUNG FISHERMEN'S ASSOCIATION", "nameZh": "屏東區漁會信用部" },
  { "code": "964", "nameEn": "DONGGANG FISHERMEN'S ASSOCIATION", "nameZh": "東港區漁會信用部" },
  { "code": "965", "nameEn": "LIUQIU FISHERMEN'S ASSOCIATION", "nameZh": "琉球區漁會信用部" },
  { "code": "966", "nameEn": "HUALIEN FISHERMEN'S ASSOCIATION", "nameZh": "花蓮區漁會信用部" },
  { "code": "967", "nameEn": "CHENGGONG FISHERMEN'S ASSOCIATION", "nameZh": "成功區漁會信用部" },
  { "code": "968", "nameEn": "TAITUNG FISHERMEN'S ASSOCIATION", "nameZh": "台東區漁會信用部" },
  { "code": "969", "nameEn": "PENGHU FISHERMEN'S ASSOCIATION", "nameZh": "澎湖區漁會信用部" },
  { "code": "970", "nameEn": "KINMEN FISHERMEN'S ASSOCIATION", "nameZh": "金門區漁會信用部" },
  { "code": "971", "nameEn": "LIENCHIANG FISHERMEN'S ASSOCIATION", "nameZh": "連江區漁會信用部" }
];